module.exports = __webpack_public_path__ + "6d46467856bf9ec24873846374b8832a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fair/business3.png
// module id = ./assets/images/fair/business3.png
// module chunks = 0